(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["left-text-right-accordion"] && !Shopify.designMode) return;
  try {
    
  /* Alpine.js is loaded globally; no inline JS needed beyond x-data/x-show bindings */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
      window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
          const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
          thisHeader.classList.add('shoplift-offer-bar-sticky');

          const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

          const mainInitialTop = mainHeader?.offsetTop;
          const stickyStart = mainHeader ? mainHeader?.offsetTop + mainHeader?.clientHeight : 0;
          let lastScroll = window.scrollY;
          document.addEventListener('scroll', (scrollEvent) => {
            if (!thisHeader) return;

            // Do it quick and dirty
            const mainHidden = mainHeader && window.scrollY > lastScroll;
            lastScroll = window.scrollY;

            const makeSticky =
              window.pageYOffset > stickyStart ||
              (mainHeader &&
                window.pageYOffset > mainInitialTop &&
                mainHeader.parentElement.classList.contains('shopify-section-header-sticky'));

            thisHeader.classList.toggle('shoplift-offer-bar-sticky', makeSticky);

            if (!makeSticky) return;

            let topPosition = 0;

            if (mainHeader && !mainHidden) topPosition += mainHeader.clientHeight;

            thisHeader.style.top = topPosition + 'px';
          });
        }
      });
    
  } catch(e) { console.error(e); }
})();
})();
